// extracted by mini-css-extract-plugin
export var valuesCardsSection = "valuesCardsStyles-module--values-cards-section--3d2-0";